function commaIt(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

angular.module(NgAppName).filter('display', [function() {
	return function(str, show) {
		return show ? str : '';
	};
}]);

angular.module(NgAppName).filter('after', [function() {
	return function(str, str_after) {
		return str ? str + str_after : '';
	};
}]);

angular.module(NgAppName).filter('before', [function() {
	return function(str, str_before) {
		return str ? str_before + str : '';
	};
}]);

angular.module(NgAppName).filter('shortNumber', [function() {
	return function(number, precision) {
		if (precision === undefined) {
			precision = 0;
		}
		var scale = Math.pow(10, precision);

		if (number > 999444) {
			return Math.round(number * scale / 1000000) / scale + 'M';
		} else if (number > 999) {
			return Math.round(number * scale / 1000) / scale + 'K';
		} else {
			return number;
		}
	};
}]);

angular.module(NgAppName).filter('shortNumberWithComma', [function() {
	return function(number, precision = 0) {
		const scale = Math.pow(10, precision);
		//? why 999444??
		let affix = '', num; 
		if (number > 999444) {
			num = Math.round(number * scale / 1000000) / scale;
			affix = 'M';
		} else if (number > 999) {
			num = Math.round(number * scale / 1000) / scale;
			affix = 'K';
		} else {
			num = number;
			affix = ''
		}

		const ret = commaIt(num);
		return `${ret}${affix}`;
	};
}]); 

angular.module(NgAppName).filter('numberWithCommas', [function() {
	return commaIt;
}]);

angular.module(NgAppName).filter('noRoundingShortNumber', [function() {
	return function(number) {
		var length = number.toString().length;
		// to the nearest thousandth
		if (number > 999999) {
			number /= 1000000;
			number = Math.floor(number * 1000) / 1000;
			return number + 'M';
		} else if (number > 999) {
			number /= 1000;
			number = Math.floor(number * 1000) / 1000;

			//CRFOUR-294
			number = number.toString();
			if (length === 6 && number.indexOf('.') > -1) {
				number = number.split('.');
				number = number[0]; // dont show decimals for 6 digit listing
			}

			return number + 'K';
		} else {
			return number;
		}
	};
}]);

angular.module(NgAppName).filter('replaceIfZero', [function() {
	return function(number, str) {
		return number === 0 ? (str ? str : '-') : number;
	};
}]);

angular.module(NgAppName).filter('applyCurrency', [function() {
	return function(str, currency) {
		if (str === '-' || str === '0' || str === 0) return str;

		return (currency ? currency : '$') + str;
	};
}]);

angular.module(NgAppName).filter('formatBudget', [function() {
	return function(str, currency) {
		if (!str) {
			return;
		}

		str = str.toString();
		var newStr = '';
		var nbChar = 1;
		for (var i = str.length - 1; i >= 0; i--) {
			newStr += str[i];
			if (nbChar % 3 === 0 && nbChar !== str.length) {
				newStr += ',';
			}
			nbChar++;
		}
		var reverseStr = newStr.split('').reverse().join('');
		return ((currency || currency === '') ? currency : '$') + reverseStr;
	};
}]);

angular.module(NgAppName).filter('replaceRegexp', [function() {
	return function(str, expression, toWhat) {
		if (!str || !expression) return str;

		var regex = new RegExp(expression, 'ig');

		return str.replace(regex, toWhat);
	};
}]);

angular.module(NgAppName).filter('shrinkString', [function() {
	return function(str, numberOfCharsLeft, numberOfCharsRight, replacer) {
		str += '';
		if (str.length <= numberOfCharsLeft || str.length <= numberOfCharsRight) return str;

		if (!replacer && replacer !== '') {
			replacer = '...';
		}

		return str.substr(0, numberOfCharsLeft) + replacer + (numberOfCharsRight ? str.substr(str.length - numberOfCharsRight, str.length) : '');
	};
}]);

angular.module(NgAppName).filter('bold', [function() {
	return function(text, substr) {
		if (!substr) return text;

		return text.replace(new RegExp('(' + substr + ')', 'gi'), '<strong>$1</strong>');
	};
}]);

angular.module(NgAppName).filter('putEmptyToEnd', [function() {
	return function(array, key) {
		if (!array) return;
		var present = array.filter(function(item) {
			return item[key] || item.type === 'ads';
		});

		var empty = array.filter(function(item) {
			return item.type !== 'ads' && !item[key];
		});
		
		return present.concat(empty);
	};
}]);

angular.module(NgAppName).filter('camelCase', [function() {
	return function(str) {
		return str.toLowerCase().replace(/ (.)/g, function(match, group) {
			return group.toUpperCase();
		});
	};
}]);

angular.module(NgAppName).filter('underscore', [function() {
	return function(str) {
		return str.toLowerCase().replace(/ (.)/g, function(match, group) {
			return '_' + group;
		});
	};
}]);

angular.module(NgAppName).filter('capitalize', [function() {
	return function(string) {
		if (string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}
		return '';
	};
}]);

angular.module(NgAppName).filter('articleDateFormat', [function() {
	return function(received_date) {
		var options = {month: 'long', day: 'numeric', year: 'numeric'};
		var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

		var now = new Date();
		var date = new Date(received_date);
		var date_string = date.toLocaleDateString('en-US', options);

		if (date.toDateString() === now.toDateString()) {
			date_string = 'Today, ' + date_string;
		} else {
			date_string = weekdays[date.getDay()] + ', ' + date_string;
		}

		return date_string;
	};
}]);
angular.module(NgAppName).filter('userDateFormat', [function() {
	return function(received_date) {
		var options;
		var date_string;

		var now = new Date();
		var date = new Date(received_date * 1000);

		if (date.toDateString() === now.toDateString()) {
			options = {hour: 'numeric', minute: 'numeric', hour12: true};
			date_string = 'Today at ' + date.toLocaleTimeString('en-US', options);
		} else {
			options = {month: 'short', day: 'numeric'};
			date_string = date.toLocaleDateString('en-US', options);
		}

		return date_string;
	};
}]);

angular.module(NgAppName).filter('customDayName', [function() {
	return function(received_date) {
		var weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
		var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

		var today = new Date();
		var date = new Date(received_date);

		var fixDay = function(day) {
			return day < 10 ? '0' + day : day;
		};

		var date_string = months[date.getMonth()] + ' ' + fixDay(date.getDate());
		var tomorrow = moment().add(1, 'd');

		if (date.toDateString() === today.toDateString()) {
			date_string = 'Today, ' + date_string;
		} else if (date.toDateString() === tomorrow._d.toDateString()) {
			date_string = 'Tomorrow, ' + date_string;
		} else {
			date_string = weekdays[date.getDay()] + ', ' + date_string;
		}
		return date_string;
	};
}]);
angular.module(NgAppName).filter('monthDayYear', [function() {
	return function(received_date) {
		return moment(received_date).format('MMM DD, YYYY');
	};
}]);

angular.module(NgAppName).filter('displayInitials', [function() {
	return function(string) {
		var str = string;
		var initial = '';
		var index;

		if (!str) return;

		if (str.indexOf(' ') > -1) {
			str = string.split(' ');

			for (var n = 0; n < str.length; n++) {
				index = str[n].substring(0, 1) === '(' ? 1 : 0;
				initial += str[n].substring(index, index + 1) + '.';
				initial += n === str.length - 1 ? '' : ' ';
			}
		} else {
			index = str.substring(0, 1) === '(' ? 1 : 0;
			initial = str.substring(index, index + 1) + '.';
		}

		return initial;
	};
}]);

angular.module(NgAppName).filter('removeUnitParentheses', [function() {
	return function(string) {

		// if number, convert it to a string
		if (typeOf(string) === 'number') {
			string = string.toString();
		}

		if (string.indexOf('(') === -1) {
			return string;
		}

		return string.substring(0, string.indexOf('('));
	};
}]);

angular.module(NgAppName).filter('searchTerm', [function() {
	return function(string, term) {
		var re = new RegExp(term, "i");
		return string.filter((t) => {
			if (t.name.search(re) > -1 ) {
				return t;
			}
		});
	};
}]);
